export default function downloadFileId(data) {
    const [fileId, fileName] = data.filename.split('::');
    this.downloadFile({
        id: fileId,
        module: 'FieldFile',
        name: fileName,
        params: this.objectToFormdata({forceDownload: true}),
    });
}
